import { render } from "./RevenueReport.vue?vue&type=template&id=795602a0&scoped=true&ts=true"
import script from "./RevenueReport.vue?vue&type=script&lang=ts"
export * from "./RevenueReport.vue?vue&type=script&lang=ts"

import "./RevenueReport.vue?vue&type=style&index=0&id=795602a0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795602a0"]])

export default __exports__